export default __webpack_public_path__ + "static/media/print_icon.fa7c11c9.svg";